import $ from 'jquery';
import ChairishState from 'chairisher/util/state';

/**
 * @constructor
 * @class PortfolioFiltersView
 */
const PortfolioFiltersView = function () {
    this._state = new ChairishState({
        filterAndSortNames: ['room', 'style', 'page'],
    });

    this._bindFacets();
};

/**
 * @type {string}
 * @private
 */
PortfolioFiltersView.prototype._filterFormSelector = '#js-portfolio-filter';

/**
 * Handles submitting data to the server when a domElement changes.
 *
 * @param {HTMLElement} domElement The element which just changed.
 * @private
 */
PortfolioFiltersView.prototype._handleSubmit = function (inputFacet) {
    const $inputFacet = $(inputFacet);
    const stateVal = $inputFacet.val();
    const stateName = $inputFacet.attr('name');
    const isChecked = $inputFacet.is(':checked');

    // with any state change we need to remove page since it's a new set of results that starts on page 1
    this._state.removeState('page', undefined, false);

    if (isChecked) {
        this.pushState(stateName, stateVal);
    } else {
        this._state.removeState(stateName, stateVal);
    }

    this._state.pushState();

    this.submit();
};

/**
 * Appends a new state to the state object, and pushes the state to the browser history.
 * If you don't want to change the browser history, pass in `false` as the 3rd argument.
 *
 * @param {string} fieldName The name of the facet input being added to the state object
 * @param {string} fieldValue The value of the facet input being added to the state object
 * @param {boolean} opt_shouldPersist True indicates the state should be persisted to window.history. Defaults to true.
 */
PortfolioFiltersView.prototype.pushState = function (fieldName, fieldValue) {
    let currentVal = this._state.getStateVal(fieldName);

    if (currentVal) {
        if (Array.isArray(currentVal)) {
            currentVal.push(fieldValue);
        } else {
            currentVal = [currentVal, fieldValue];
        }
    } else {
        currentVal = fieldValue;
    }

    this._state.setStateVal(fieldName, currentVal);

    this._state.pushState();
};

/**
 * @returns {$.Deferred}
 */
PortfolioFiltersView.prototype.submit = function () {
    return $.ajax({
        dataType: 'json',
        url: this._state.getStateUrl(),
    }).done(
        $.proxy((data) => {
            $('.js-paginator-wrapper').html(data.data.pager_truncated_html.trim());
            $('.js-business-image-grid-wrapper').html(data.data.business_images_html);
        }, this),
    );
};

/**
 * Binds actions that are related to filters form
 *
 * @private
 */
PortfolioFiltersView.prototype._bindFacets = function () {
    const $filtersForm = $(this._filterFormSelector);

    $filtersForm.on(
        'change',
        'input',
        $.proxy(function (e) {
            this._handleSubmit(e.currentTarget);
        }, this),
    );
};

export default PortfolioFiltersView;
